import { render } from "./InputRadioList.vue?vue&type=template&id=25cc3683"
import script from "./InputRadioList.vue?vue&type=script&lang=js"
export * from "./InputRadioList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__